import API from '../Services/API';
import { useSession } from '../Components/Session';
import Model from './Model';

const useGrants = () => {
    return Model({
        stateKey: ['users', 'grants'],
        // alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get('/users/grants'),
        returnDataKey: 'grants',
        defaultLoadingError: 'Sorry, there was an error loading your other accounts.',
    })
}

const useUser = (alwaysRefresh) => {
    const {refresh} = useSession();

    return Model({
        stateKey: 'user',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get('/user'),
        returnDataKey: 'user',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user', data).then(refresh),
                        null,
                        true,
                    );
                },
                changePassword: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/changePassword', data),
                        null,
                        true,
                    );
                },
                changeEmail: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/changeEmail', data),
                        null,
                        true,
                    );
                },
                closeAccount: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/closeAccount', data),
                        null,
                        true,
                    );
                },
                resetAccount: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/user/resetAccount', data),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading your account.',
    })
}

const hasRole = (role) => {
    return API.isRoleSufficient(role);
}

const Roles = {
    Owner: 'Owner',
    Manager: 'Manager',
    Worker: 'Worker',
    LimitedWorker: 'Limited Worker',
}

export {
    useUser,
    useGrants,
    hasRole,
    Roles,
}
